module.exports = __webpack_public_path__ + "img/11.d14c29a0.svg";